import { ResponsePaginationApiModel } from '@framework/models/api-models';
import { NotificationOutputApiModel } from '@app/store/http/models/output';

export interface ResponsePaginationNotificationApiModel extends  ResponsePaginationApiModel<NotificationOutputApiModel> {
    count_unread: number;
}
